export default __webpack_public_path__ + "static/media/happy-bunch-3.33315aa0.svg";